import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../../../data-storage.service';
import {NewPhoneNumbersRange} from '../../../../../models/newPhoneNumbersRange';
import {NumbersPricingModel} from '../../../../../models/numbersPricing.model';
import {ApiService} from '../../../../api.service';
import {PricingService} from '../../../../pricing.service';
import {NiceNumbersModel} from '../../../../../models/niceNumbers.model';

@Component({
  selector: 'app-range',
  templateUrl: './range.component.html',
  styleUrls: ['./range.component.scss']
})
export class RangeComponent implements OnInit {

  connections: string[];
  counts: number[];
  niceNumber: string[];
  pricingList: NumbersPricingModel[];
  niceList: NiceNumbersModel[];

  constructor(
    public dataStorageService: DataStorageService,
    private api: ApiService,
    private pricing: PricingService) {
    this.connections = [];
    this.counts = [];
    this.niceNumber = [];
    this.pricingList = [];

    const connectionType = new Set();
    const totalCount = new Set();
    const niceNumbers = new Set();
    pricing.getNewNumbersPricelist().then(data => {
      this.pricingList = data;
      data.map(e => {
        connectionType.add(e.connectionType);
        totalCount.add(e.totalCount);
      });
      this.connections = Array.from(connectionType);
    });

    this.pricing.getNewNumbersNiceOptions()
      .then(data => {
        this.niceList = data;
        this.niceList.map(e => niceNumbers.add(e.option));
        this.niceNumber = Array.from(niceNumbers);
      });

  }

  filterTotalCount(conn: string) {
    const filtered = this.pricingList.filter(e => {
      return e.connectionType === conn;
    });
    const toReturn = new Set();
    filtered.map(e => {
      toReturn.add(e.totalCount);
    });
    return Array.from(toReturn).length !== 0 ? Array.from(toReturn) : ['none available'];
  }

  ngOnInit() {
  }

  addRangeClick() {
    this.api.postNewNumbers(this.dataStorageService.currentState.offerID)
      .then((range) => {

        range.costMonthly = this.calculateMonthly(range);
        range.costUnique = this.calculateUnique(range);

        this.dataStorageService.currentState.newPhoneNumber.range.push(range);
      });
  }

  removeRangeClick(i: number) {
    this.api.deleteNewNumbers(
      this.dataStorageService.currentState.offerID,
      this.dataStorageService.currentState.newPhoneNumber.range[i].id)
      .then(() => {
        this.dataStorageService.currentState.newPhoneNumber.range.splice(i, 1);
      });
  }

  /**
   * @param i       position in array
   * @param event   event from HTML
   * @param field   name of field in NewPhoneNumberRange
   */
  setRangeValue(i: number, event: any, field: string) {
    const range = this.dataStorageService.currentState.newPhoneNumber.range[i];

    range[field] = event.target.value;

    if (field === 'connectionType') {
      range.totalCount = this.filterTotalCount(range.connectionType)[0];
      range.offeredCount = this.pricingList
        .filter(e => e.connectionType === range.connectionType)
        .filter(e => e.totalCount === range.totalCount)[0].offeredCount;
    }

    range.costMonthly = this.calculateMonthly(range);
    range.costUnique = this.calculateUnique(range);

    this.api.putNewNumbers(this.dataStorageService.currentState.offerID);
  }

  calculateMonthly(range: NewPhoneNumbersRange) {
    const filtered = this.pricingList.filter(e => e.connectionType === range.connectionType);
    range.totalCount = parseInt(range.totalCount.toString(), 10);
    const count = filtered.filter(e => e.totalCount === range.totalCount);
    range.costMonthlyEdit = count.length === 1 ? count[0].costMonthlyEdit : false;

    return count.length === 1 ? count[0].costMonthly : 0;
  }

  calculateUnique(range: NewPhoneNumbersRange) {
    const filtered = this.pricingList.filter(e => e.connectionType === range.connectionType);
    range.totalCount = parseInt(range.totalCount.toString(), 10);
    const count = filtered.filter(e => e.totalCount === range.totalCount);

    const nice = this.niceList.filter(e => e.option === range.cat);
    range.costUniqueEdit = count.length === 1 ? count[0].costUniqueEdit : false;
    return count.length === 1 && nice.length === 1 ? count[0].costUnique + nice[0].costUnique : 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/new-phone-numbers/range/range.component.ts